
const calcStep = (first, second, amount) => {
    return Math.abs((second - first) / amount)
}

const midArray = (first, second, amount, step) => {
    let array = []
    if (first > second) {
        for (let i = 0; i < amount; i++) {
            array.push(first - step * i)
        }
    } else {
        for (let i = 0; i < amount; i++) {
            array.push(first + step * i)
        }
    }
    return array
}

function colorValues(color) {
    if (!color)
        return;
    if (color.toLowerCase() === 'transparent')
        return [0, 0, 0, 0];
    if (color[0] === '#') {
        if (color.length < 7) {
            // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
            color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
        }
        return [parseInt(color.substr(1, 2), 16),
        parseInt(color.substr(3, 2), 16),
        parseInt(color.substr(5, 2), 16),
        color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1];
    }
    if (color.indexOf('rgb') === -1) {
        // convert named colors
        var temp_elem = document.body.appendChild(document.createElement('fictum')); // intentionally use unknown tag to lower chances of css rule override with !important
        var flag = 'rgb(1, 2, 3)'; // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
        temp_elem.style.color = flag;
        if (temp_elem.style.color !== flag)
            return; // color set failed - some monstrous css rule is probably taking over the color of our object
        temp_elem.style.color = color;
        if (temp_elem.style.color === flag || temp_elem.style.color === '')
            return; // color parse failed
        color = getComputedStyle(temp_elem).color;
        document.body.removeChild(temp_elem);
    }
    if (color.indexOf('rgb') === 0) {
        if (color.indexOf('rgba') === -1)
            color += ',1'; // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
        return color.match(/[\.\d]+/g).map(function (a) {
            return +a
        });
    }
}


export const calculateColors = ({ firstColor, secondColor, amount }) => {
    let arrayOfColors = []
    let arrayOfColorsRed = []
    let arrayOfColorsGreen = []
    let arrayOfColorsBlue = []
    let arrayOfColorsAlpha = []


    const [firstColorRed, firstColorGreen, firstColorBlue, firstColorAlpha] = colorValues(firstColor)
    const [secondColorRed, secondColorGreen, secondColorBlue, secondColorAlpha] = colorValues(secondColor)
    arrayOfColorsRed = midArray(firstColorRed, secondColorRed, amount, Math.floor(calcStep(firstColorRed, secondColorRed, amount)))
    arrayOfColorsGreen = midArray(firstColorGreen, secondColorGreen, amount, Math.floor(calcStep(firstColorGreen, secondColorGreen, amount)))
    arrayOfColorsBlue = midArray(firstColorBlue, secondColorBlue, amount, Math.floor(calcStep(firstColorBlue, secondColorBlue, amount)))
    arrayOfColorsAlpha = midArray(firstColorAlpha, secondColorAlpha, amount, calcStep(firstColorAlpha, secondColorAlpha, amount))

    for (let i = 0; i < amount; i++) {
        arrayOfColors.push(`rgba(${arrayOfColorsRed[i]},${arrayOfColorsGreen[i]},${arrayOfColorsBlue[i]}, ${arrayOfColorsAlpha[i]})`)
    }
    return arrayOfColors
}



const mainColor = '#126cff'
// const mainColor = '#ff0000'
const lightColor = calculateColors({firstColor: mainColor, secondColor: '#ffffff', amount: 6})[5]
export const COLORS = {
    // deepBlue: '#3899ec',
    // deepBlue: '#126cff',
    deepBlue: mainColor,
    deepBlueHover: calculateColors({firstColor: mainColor, secondColor: '#ffffff', amount: 6})[2],
    // lightBlue: '#f6fbff',
    lightBlue: lightColor,
    lightBlueHover: calculateColors({firstColor: lightColor, secondColor: '#757575', amount: 20})[1],
    superLightBlue: calculateColors({firstColor: lightColor, secondColor: '#ffffff', amount: 6})[5],
    // mediumBlue: '#eaf7ff',
    mediumBlue: calculateColors({firstColor: mainColor, secondColor: '#ffffff', amount: 6})[4],
    wixGrey: '#d9e1e8',
    darkText: '#2B5672',
    hoverBlue: '#cfeeff',
    // hoverBlueDark: '#4eb7f5',
    hoverBlueDark: '#5999ff',
    darkBlue: '#2b81cb',
    red: '#f5425d',
    darkLightBlue: '#9CBFF3',
    superDarkBlue: '#0d487f',
    premium: '#AA34CA',
    wixDarkGrey: '#7a92a5',
    deepRed: '#ff1212'
}